export default __webpack_public_path__ + "static/media/photo--lg--57.78ca26b5.jpg";